import Axios, { AxiosObservable } from 'axios-observable';
import { CONFIG } from 'const/config';
import { EmploymentTypeServiceResponseInterfaceTypes } from 'types';

export const employmentTypesService =
  (): AxiosObservable<EmploymentTypeServiceResponseInterfaceTypes> =>
    Axios.get(`${CONFIG.API_URL}/employment_types`);
